import React from "react";

const Footer = () => (
  <div className="mt-12">
    <p className="select-none dark:text-gray-200 text-gray-700 text-center m-20 hover:text-blue">
      © 2022 All rights reserved by ModernVate.com <br /> Designed By
      @TechFusion
    </p>
  </div>
);

export default Footer;
